import { IRouteType } from '../../types'
import fwWingstopPAndL from '../common/pnl'
import fwWingstopPAndLConfig from '../common/pnlConfig'
import fwWingstopPAndLRankings from '../common/pnlRankings'
import fwWingstopexEcutiveScorecard from './fwExecutiveScorecard'
import fwForecast from './fwForecast'
import fwSmartKitchen from './fwSmartKitchen'
import fwSmartKitchenOperational from './fwSmartKitchenOperational'
import fwSssBreakdownChart from './fwSssBreakdownChart'
import fwSystemwideOverviewConfig from './fwSystemwideOverview'
import fwUploadReportConfig from './fwUploadReport'
import fwUpsell from './fwUpsell'
import fwWingstopAiBlackbox from './fwWingstopAiBlackbox'
import fwWingstopCalls from './fwWingstopCalls'
import fwWingstopCorporateGuestConfig from './fwWingstopCorporateGuest'
import fwWingstopCorporateIntraday from './fwWingstopCorporateIntraday'
import fwWingstopCorporateLossPreventionConfig from './fwWingstopCorporateLossPreventionConfig'
import fwWingstopDailyOps from './fwWingstopDailyOps'
import fwWingstopDailySalesKpisReport from './fwWingstopDailySalesKpisReport'
import fwWingstopDayPartReport from './fwWingstopDayPartReport'
import fwWingstopDeliveryDaySchedules from './fwWingstopDeliveryDaySchedules'
import fwWingstopDigitalNondigital from './fwWingstopDigitalNondigital'
import fwWingstopExpoAi from './fwWingstopExpoAi'
import fwWingstopFinancialChart from './fwWingstopFinancialChart'
import fwWingstopFlashCogsTracker from './fwWingstopFlashCogsTracker'
import fwWingstopFlashDiscountsAndVoids from './fwWingstopFlashDiscountsAndVoids'
import fwWingstopFlashFoodCost from './fwWingstopFlashFoodCost'
import fwWingstopFlashProductMix from './fwWingstopFlashProductMix'
import fwWingstopFlashSalesAndTicketCompReport from './fwWingstopFlashSalesAndTicketCompReport'
import fwWingstopFlashSalesByOrderMode from './fwWingstopFlashSalesByOrderMode'
import fwWingstopFlashWeeklyLaborTracker from './fwWingstopFlashWeeklyLaborTracker'
import fwWingstopGroupManagement from './fwWingstopGroupManagement'
import fwWingstopGuestConfig from './fwWingstopGuest'
import fwWingstopHome from './fwWingstopHome'
import fwWingstopLaborTrend from './fwWingstopLaborTrend'
import fwWingstopLocationManagement from './fwWingstopLocationManagement'
import fwWingstopLossPreventionConfig from './fwWingstopLossPreventionConfig'
import fwWingstopManualDataCorrection from './fwWingstopManualDataCorrection'
import fwWingstopOriginalStorePages from './fwWingstopOriginalStorePages'
import fwWingstopOutliers from './fwWingstopOutliers'
import fwWingstopPrepItemAdminSetting from './fwWingstopPrepItemAdminSetting'
import fwWingstopPrepItemCalculator from './fwWingstopPrepItemCalculator'
import fwWingstopPrepItemConfiguration from './fwWingstopPrepItemConfiguration'
import fwWingstopPrepToolFeedback from './fwWingstopPrepToolFeedback'
import fwWingstopR365SalesByOrderMode from './fwWingstopR365SalesByOrderMode'
import fwWingstopSalesAlertDashboard from './fwWingstopSalesAlertDashboard'
import fwWingstopStorePerformance from './fwWingstopStorePerformance'
import fwWingstopTimeClock from './fwWingstopTimeClock'
import originalCorporatePages from './originalCorporatePages'

export const routes: IRouteType[] = [
  {
    title: 'Corporate',
    children: [
      {
        title: 'Executive Scorecard',
        link: '/:brand/scorecard',
      },
      {
        title: 'AI Blackbox',
        link: '/:brand/ai_blackbox',
        hideFromNavMenu: true,
      },
      {
        title: 'Expo AI',
        link: '/:brand/expo_ai',
      },
      {
        title: 'Systemwide Overview',
        link: '/:brand/systemwide_overview',
        default: true,
      },
      {
        title: 'Ops Excellence',
        link: '/:brand/corporate_guest',
      },
      {
        title: 'Delivery',
        link: '/:brand/corporate_delivery',
        useOriginal: true,
      },
      {
        title: 'Financial Chart',
        collapsible: true,
        children: [
          {
            title: 'Total Sales',
            link: '/:brand/sales_chart',
          },
          {
            title: 'SSS/SST/SSC',
            link: '/:brand/sss_chart',
          },
          {
            title: 'SSS Breakdown',
            link: '/:brand/sss_breakdown',
          },
          {
            title: 'Check Average',
            link: '/:brand/check_average_chart',
          },
        ],
      },
      {
        title: 'Smart Kitchen',
        collapsible: true,
        children: [
          {
            title: 'Smart Kitchen',
            link: '/:brand/smart_kitchen',
          },
          {
            title: 'Smart Kitchen Operational',
            link: '/:brand/smart_kitchen_operational',
          },
        ],
      },
      {
        title: 'Operator Focus',
        collapsible: true,
        children: [
          {
            title: 'Sales Alert Dashboard',
            link: '/:brand/sales_alert_dashboard',
          },
          {
            title: 'Ops Report',
            link: '/:brand/ops_report',
          },
          {
            title: 'Outliers',
            link: '/:brand/outliers',
          },
          {
            title: 'Food Cost by Store',
            link: '/:brand/food_cost',
          },
          {
            title: 'Time Clock',
            link: '/:brand/corporate_time_clock',
          },
          {
            title: 'Schedule vs. Matrix',
            link: '/:brand/forecast',
          },
          {
            title: 'Loss Prevention',
            link: '/:brand/corporate_loss_prevention',
          },
          {
            title: 'Discounts / Voids / Refunds',
            link: '/:brand/discounts_and_voids',
          },
          {
            title: 'Labor Trend',
            link: '/:brand/labor_trend',
          },
          {
            title: 'Calls',
            link: '/:brand/corporate_calls',
          },
        ],
      },
      {
        title: 'Prime Cost',
        collapsible: true,
        children: [
          {
            title: 'Cogs Tracker',
            link: '/:brand/cogs_tracker',
          },
          {
            title: 'Weekly Labor Tracker',
            link: '/:brand/weekly_labor_tracker',
          },
        ],
      },
      {
        title: 'Sales Analytics',
        collapsible: true,
        children: [
          {
            title: 'Daily Sales KPI',
            link: '/:brand/daily_sales_kpis_report',
          },
          {
            title: 'Sales & Ticket Comp Report',
            link: '/:brand/sales_and_ticket_comp',
          },
          {
            title: 'Sales by Order Mode (NBO)',
            link: '/:brand/sales_by_order_mode',
          },
          {
            title: 'Sales by Order Mode (R365)',
            link: '/:brand/r365_sales_by_order_mode',
          },
          {
            title: 'Sales by Order Mode (R365 by Location)',
            link: '/:brand/r365_store_sales_by_order_mode',
          },
          {
            title: 'Sales by Order Mode Detailed Export',
            link: '/:brand/sales_by_order_mode_detailed_export',
          },
          {
            title: 'Digital vs. Non-Digital Sales',
            link: '/:brand/digital_nondigital',
          },
          {
            title: 'Daypart Sales',
            link: '/:brand/day_part_report',
          },
          {
            title: 'Hourly Sales',
            link: '/:brand/corporate_intraday',
          },
          {
            title: 'Upsell',
            link: '/:brand/upsell',
          },
        ],
      },
      {
        title: 'Customized Reports',
        collapsible: true,
        children: [
          {
            title: 'Product Mix',
            link: '/:brand/product_mix',
          },
        ],
      },
    ],
  },
  {
    title: 'Store',
    children: [
      {
        title: 'Home',
        link: '/:brand/home',
      },
      {
        title: 'Store Performance',
        link: '/:brand/store_detail',
      },
      {
        title: 'Loss Prevention',
        link: '/:brand/loss_prevention',
      },
      {
        title: 'Ops Excellence',
        link: '/:brand/guest',
      },
      {
        title: 'Delivery',
        link: '/:brand/delivery',
        useOriginal: true,
      },
      {
        title: 'Calls',
        link: '/:brand/calls',
      },
      {
        title: 'Prep Item Calculator',
        link: '/:brand/prep_item_calculator',
        default: true,
      },
      {
        title: 'Prep Tool Feedback',
        link: '/:brand/prep_tool_feedback',
      },
    ],
  },
  {
    title: 'Administration',
    children: [
      {
        title: 'Groups',
        link: '/:brand/groups',
      },
      {
        title: 'Locations',
        link: '/:brand/locations',
      },
      {
        title: 'Upload Reports',
        link: '/:brand/upload-reports',
      },
      {
        title: 'Manual NBO Data Correction',
        link: '/:brand/manual_data_correction',
      },
      {
        title: 'Prep Item Admin Setting',
        link: '/:brand/prep_item_admin_setting',
      },
      {
        title: 'Prep Item Configuration',
        link: '/:brand/prep_item_configuration',
      },
      {
        title: 'Delivery Day Schedules',
        link: '/:brand/delivery_day_schedules',
      },
    ],
  },
  {
    title: 'P&L',
    children: [
      {
        title: 'Expo AI P&L',
        link: '/:brand/pnl',
      },
      {
        title: 'Expo AI P&L Rankings',
        link: '/:brand/pnl-rankings',
      },
      {
        title: 'Config',
        link: '/:brand/pnl-config',
        hideFromNavMenu: true,
      },
    ],
  },
]

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  originalCorporatePages,
  fwWingstopFlashSalesAndTicketCompReport,
  fwWingstopFlashWeeklyLaborTracker,
  fwWingstopFlashCogsTracker,
  fwWingstopFlashProductMix,
  fwWingstopFlashDiscountsAndVoids,
  fwWingstopFlashFoodCost,
  fwWingstopDailyOps,
  fwWingstopOutliers,
  fwWingstopFlashSalesByOrderMode,
  fwWingstopTimeClock,
  fwUploadReportConfig,
  fwWingstopOriginalStorePages,
  fwWingstopGroupManagement,
  fwWingstopLocationManagement,
  fwWingstopDailySalesKpisReport,
  fwWingstopFinancialChart,
  fwWingstopLossPreventionConfig,
  fwWingstopCorporateLossPreventionConfig,
  fwWingstopGuestConfig,
  fwWingstopCorporateGuestConfig,
  fwWingstopExpoAi,
  fwWingstopHome,
  fwSystemwideOverviewConfig,
  fwWingstopSalesAlertDashboard,
  fwWingstopDigitalNondigital,
  fwWingstopDayPartReport,
  fwWingstopPAndL({
    brand: 'fw_wingstop-pnl-nq4f6yut',
    startDate: '2023-12-31',
  }),
  fwWingstopPAndLConfig('fw_wingstop-pnl-nq4f6yut'),
  fwWingstopPAndLRankings({ brand: 'fw_wingstop-pnl-nq4f6yut' }),
  fwWingstopAiBlackbox,
  fwWingstopManualDataCorrection,
  fwWingstopCorporateIntraday,
  fwWingstopStorePerformance,
  fwWingstopPrepItemConfiguration,
  fwWingstopPrepItemCalculator,
  fwWingstopPrepItemAdminSetting,
  fwWingstopDeliveryDaySchedules,
  fwUpsell,
  fwForecast,
  fwSmartKitchen,
  fwSmartKitchenOperational,
  fwWingstopLaborTrend,
  fwSssBreakdownChart,
  fwWingstopR365SalesByOrderMode,
  fwWingstopPrepToolFeedback,
  fwWingstopCalls,
  fwWingstopexEcutiveScorecard,
]
